import scrollIntoView from 'scroll-into-view-if-needed';
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "GlossaryApp/ts/services/glossary.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
function GlossaryIndexComponent_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵlistener("click", function GlossaryIndexComponent_a_13_Template_a_click_0_listener() { const letter_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.scrollToLetter(letter_r2)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const letter_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(letter_r2);
} }
function GlossaryIndexComponent_div_15_a_4__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 18);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-video");
} }
function GlossaryIndexComponent_div_15_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 13);
    i0.ɵɵlistener("click", function GlossaryIndexComponent_div_15_a_4_Template_a_click_0_listener() { const term_r5 = i0.ɵɵrestoreView(_r4).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.navigateToDefinitionPage(term_r5.internalName)); });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, GlossaryIndexComponent_div_15_a_4__svg_svg_3_Template, 1, 1, "svg", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const term_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(term_r5.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", term_r5.videoLink);
} }
function GlossaryIndexComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtemplate(4, GlossaryIndexComponent_div_15_a_4_Template, 4, 2, "a", 10);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const letter_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", i0.ɵɵinterpolate(letter_r6));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(letter_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.terms[letter_r6]);
} }
export class GlossaryIndexComponent {
    constructor(urlsService, glossaryService) {
        this.urlsService = urlsService;
        this.glossaryService = glossaryService;
        this.letters = [];
        this.terms = {};
    }
    ngOnInit() {
        this.glossaryService.getGlossaryData().subscribe((data) => {
            this.letters = data.letters;
            this.terms = data.terms;
        });
    }
    navigateToDefinitionPage(term) {
        if (term !== undefined) {
            window.location.href = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM, { term });
        }
    }
    scrollToLetter(letter) {
        setTimeout(() => {
            const querySelector = `.glossary-index-item[id="${letter}"]`;
            const target = document.querySelector(querySelector);
            if (target) {
                scrollIntoView(target, {});
            }
        }, 0);
    }
}
GlossaryIndexComponent.ɵfac = function GlossaryIndexComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GlossaryIndexComponent)(i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.GlossaryService)); };
GlossaryIndexComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlossaryIndexComponent, selectors: [["ycn-glossary-index"]], standalone: false, decls: 16, vars: 5, consts: [[1, "page-header", "page-header-support"], [1, "container"], [1, "row"], [1, "col-auto"], [1, "page-title"], [1, "form-inline"], [1, "form-label", "form-label-thin"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], [1, "page-subheader"], [1, "glossary-abc", "container"], ["href", "javascript:void(0)", 3, "click", 4, "ngFor", "ngForOf"], [1, "glossary-index", "page-body", "container"], ["class", "glossary-index-item", 3, "id", 4, "ngFor", "ngForOf"], ["href", "javascript:void(0)", 3, "click"], [1, "glossary-index-item", 3, "id"], [1, "glossary-index-item-title"], [1, "glossary-index-item-content"], ["ycnIcon", "", 3, "name", 4, "ngIf"], ["ycnIcon", "", 3, "name"]], template: function GlossaryIndexComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "h1", 4);
        i0.ɵɵtext(5, "Financial Glossary");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "div", 3)(7, "div", 5)(8, "label", 6);
        i0.ɵɵtext(9, "Search");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "ycn-icon-search-autocomplete", 7);
        i0.ɵɵlistener("submitHandler", function GlossaryIndexComponent_Template_ycn_icon_search_autocomplete_submitHandler_10_listener($event) { return ctx.navigateToDefinitionPage($event.search_id); });
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(11, "div", 8)(12, "div", 9);
        i0.ɵɵtemplate(13, GlossaryIndexComponent_a_13_Template, 2, 1, "a", 10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵtemplate(15, GlossaryIndexComponent_div_15_Template, 5, 4, "div", 12);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("appendToBody", false)("placeholder", "Search Term")("searchType", "glossary_term");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.letters);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.letters);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.IconDirective, i5.IconSearchAutocompleteComponent], encapsulation: 2 });
